module.exports = __webpack_public_path__ + "static/img/X智慧云平台.95dbffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/拖拉机/X智慧云平台.png
// module id = m1oX
// module chunks = 0